import Vue from 'vue'

import { BootstrapVue } from 'bootstrap-vue'
// import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue2-timepicker/dist/VueTimepicker.css'
import "vue-snotify/styles/material.css"
import Snotify from 'vue-snotify';

Vue.use(BootstrapVue)
Vue.use(Snotify)

// Vue.use(BootstrapVueIcons)
